jQuery(document).ready(($) => {
    let hash = window.location.hash;
    // variable_product_options
    if (hash) {
        let hash_parts = hash.split('_');
        if (hash_parts[0] !== '#variation') {
            return false;
        }
        $('.product_data_tabs .variations_options a').trigger('click');
        $('#woocommerce-product-data').on('woocommerce_variations_loaded', function () {
            "use strict";
            let $variation_box = $('.woocommerce_variations').find(`input[value=${hash_parts[1]}]`).parent('h3');
            if ($variation_box.length > 0) {
                $variation_box.trigger('click');
                $('html, body').animate({ scrollTop: $variation_box.offset().top - 30 }, 'slow');
            }
        });
    }
});
